import { MapLayerEventType, MapLayerMouseEvent, Map } from "maplibre-gl";
import { MAP_LAYERS, VIEW_LAYERS } from "../constants";
import React, { MutableRefObject, SetStateAction } from "react";
import { hoverSchool, schoolClick, unhoverSchool } from "../eventHandlers";
import { SchoolType } from "../../../../editing_planning/data_requirements";
import { SchoolSelection } from "./configureAssignments";

const getViewModeHandlers = (
  map: MutableRefObject<Map>,
  setShowMultiSchoolModal: React.Dispatch<SetStateAction<SchoolSelection>>,
  mapSchoolLevel: MutableRefObject<SchoolType>,
): {
  eventType: keyof MapLayerEventType;
  layer: string;
  handler: (e?: MapLayerMouseEvent) => void;
}[] => {
  return [
    {
      eventType: "click",
      layer: MAP_LAYERS.schoolPoints,
      handler: (e) => schoolClick(e, setShowMultiSchoolModal, mapSchoolLevel),
    },
    {
      eventType: "mouseenter",
      layer: MAP_LAYERS.schoolPoints,
      handler: (e) => hoverSchool(e, map),
    },
    {
      eventType: "mouseleave",
      layer: MAP_LAYERS.schoolPoints,
      handler: () => unhoverSchool(map),
    },
  ];
};

export const enableViewMode = (
  map: MutableRefObject<Map>,
  setShowMultiSchoolModal: React.Dispatch<SetStateAction<SchoolSelection>>,
  mapSchoolLevel: MutableRefObject<SchoolType>,
) => {
  const eventHandlers = getViewModeHandlers(
    map,
    setShowMultiSchoolModal,
    mapSchoolLevel,
  );

  eventHandlers.forEach((event) => {
    map.current.on(event.eventType, event.layer, event.handler);
  });

  VIEW_LAYERS.forEach((layer) => {
    map.current.setLayoutProperty(layer, "visibility", "visible");
  });

  return () => {
    VIEW_LAYERS.forEach((layer) => {
      map.current.setLayoutProperty(layer, "visibility", "none");
    });
    eventHandlers.forEach((event) => {
      map.current.off(event.eventType, event.layer, event.handler);
    });
  };
};
